import React from 'react';
import SelectFiled from '../../common/textfield/SelectFiled';
import { Col, Row } from 'react-bootstrap';
import TextArea from '../../common/textfield/TextArea';
import TextInput from '../../common/textfield/TextInput';
import Checkbox from '../../common/textfield/Checkbox';
import Radio from '../../common/textfield/Radio';

export const QuestionField = ({ question, formik, propIndex }) => {
    const handleRadioChange = (val) => {
        const newQuestionResponse = formik?.values?.questionResponse[propIndex].answer?.map((item) => ({
            ...item,
            answer: val === item?.option
        }));
        formik.setFieldValue(`questionResponse[${propIndex}].answer`, newQuestionResponse);
    };

    switch (question?.answerType) {
        case "freeText":
            return (
                <Col>
                    <TextArea
                        keyField={`questionResponse[${propIndex}].answer[0].answer`}
                        label={false}
                        formik={formik}
                        placeholder={"Type here..."}
                        hideRequired={true} />
                </Col>
            );
        case "singleFreeText":
            return (
                <Col>
                    <TextInput
                        keyField={`questionResponse[${propIndex}].answer[0].answer`}
                        label={false}
                        formik={formik}
                        placeholder={"Type here..."}
                        hideRequired={true} />
                </Col>
            );
        case "dropDown":
            return (
                <Row>
                    <Col>
                        <SelectFiled
                            keyField={`questionResponse[${propIndex}].answer[0].answer`}
                            label={false}
                            formik={formik}
                            options={question?.answer}
                            hideRequired={true} />
                    </Col>
                    <Col></Col>
                    <Col></Col>
                </Row>
            );
        case "radio":
            return (
                <Row>
                    {question?.answer?.map((option, index) => <Row key={option?.id}>
                        <Radio
                            key={index}
                            keyField={`questionResponse[${propIndex}].answer[${index}].answer`}
                            name={question?.text}
                            value={option?.option}
                            radioLabel={option?.option}
                            isChecked={formik?.values?.questionResponse[propIndex].answer[index].answer}
                            handleChange={handleRadioChange}
                            formik={formik}
                            hideRequired={true} />
                    </Row>
                    )}
                </Row>
            );
        case "checkbox":
            return (
                <Row>
                    {question?.answer?.map((option, index) => <Row key={option?.id}>
                        <Checkbox
                            key={index}
                            keyField={`questionResponse[${propIndex}].answer[${index}].answer`}
                            label={option?.option}
                            formik={formik}
                            checked={formik.values.questionResponse[propIndex].answer[index].answer}
                            hideRequired={true} />
                    </Row>
                    )}
                </Row>
            );
        default:
            return (<Col>test</Col>);
    }
};
